import { AnyAction } from 'redux';
import { PREV_LOCATION_ARR_LENGTH } from '../../shared/constants/commonConstants';
import { UtilState } from '../models/utilModels';
import actionTypes from '../types/utilTypes';

const initialState: UtilState = {
  isNewVersionAvilable: false,
  oldLocations: [],
  notifications: [],
  totalNotificationUnReadCount: 0,
  totalNotificationCount: 0,
  isOnNotificationFlow: false,
};

const reducer = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.NEW_VERSION_AVILABLE:
      return {
        ...state,
        isNewVersionAvilable: action.payload,
      };
    case actionTypes.UPDATE_OLD_LOCATION:
      const newArr = [action.payload, ...state.oldLocations];
      newArr.length = (newArr.length > PREV_LOCATION_ARR_LENGTH) ? PREV_LOCATION_ARR_LENGTH : newArr.length;
      return {
        ...state,
        oldLocations: newArr,
      };
    case actionTypes.SAVE_NOTIFICATIONS:
        return {
          ...state,
          notifications: action.isAppend ? [...state?.notifications, ...action.payload] : action.isFromWS
            ? [...action.payload, ...state?.notifications] : action.payload,
        };
    case actionTypes.UPDATE_IS_READ_NOTIFICATION:
      const newNotificationsArr = state.notifications?.map((ele: any): any => ({
        ...ele,
        isRead: ele?.notificationMessageId === action.payload ? true : ele?.isRead,
      })) || [];
      return {
        ...state,
        totalNotificationUnReadCount: state.totalNotificationUnReadCount - 1,
        notifications: newNotificationsArr,
      };
    case actionTypes.UPDATE_UNREAD_AND_TOTAL_COUNT:
      return {
        ...state,
        totalNotificationUnReadCount: action.payload?.totalNotificationUnReadCount,
        totalNotificationCount: action.payload?.totalNotificationCount || state.totalNotificationCount,
      };
    case actionTypes.IS_ON_NOTIFICATION_FLOW:
      return {
        ...state,
        isOnNotificationFlow: action.payload,
      };
    default: return state;
  }
};

export { reducer as utilReducer };
